// 영문/숫자만 KEBAB-CASE-UPPER로 변환
export function slugify(name) {
  return (name || '')
    .trim()
    .toUpperCase()
    .replace(/[^A-Z0-9\s_-]/g, '')
    .replace(/[\s_]+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '');
}

export const SIG_EMOJI = { green: '🟢', yellow: '🟡', white: '⚪' };
export const CAT_EMOJI = { web: '🌐', app: '📱', cloud: '☁️', svc: '⚙️', 'lib-docs': '📚', unknown: '❓' };

export function productLabel(p) {
  if (!p) return '';
  const friendly = p.name && p.name !== p.id ? p.name : p.id;
  return `${CAT_EMOJI[p.category] || ''}${SIG_EMOJI[p.signal] || ''} ${friendly} (${p.id})`;
}

export function isISODate(v) {
  return typeof v === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(v);
}
